import { useProduct } from "src/context/ProductProvider";
import ResultExpectation from "./pages/ResultExpectation";
import HairLossBeforeAfter from "./pages/HairLossBeforeAfter";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Paths } from "src/constants/paths";
import { useLocation } from "react-router-dom";
import EDReviews from "./pages/EDReviews";
import AmhReviews from "./pages/AmhReviews";
import SkinCareReviews from "../SkinCareReviews";
import SupplementsReviews from "./pages/SupplementsReviews";
import BetaBlockersReviews from "./pages/BetaBlockersReviews";

const Welcome2 = () => {
  const productSlug = useProduct((p) => p.slug);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleNavigation = useCallback(() => {
    navigate(pathname.replace("welcome-2", Paths.SIGNUP));
  }, [navigate, pathname]);

  if (productSlug === "fhl") {
    return <HairLossBeforeAfter onNavigate={handleNavigation} />;
  }

  if (productSlug === "ed-ot") {
    return <EDReviews onNavigate={handleNavigation} />;
  }

  if (productSlug === "amh-ot") {
    return <AmhReviews onNavigate={handleNavigation} />;
  }

  if (productSlug === "aa-ot") {
    return (
      <SkinCareReviews
        onNavigate={handleNavigation}
        title="Millions deal with aging skin. At HolaVida, getting real results is simple, fast, and effective"
      />
    );
  }

  if (productSlug === "ac-ot") {
    return (
      <SkinCareReviews
        onNavigate={handleNavigation}
        title="Millions struggle with acne. At HolaVida, getting clear skin is simple, fast, and effective."
      />
    );
  }

  if (productSlug === "ro-ot") {
    return (
      <SkinCareReviews
        onNavigate={handleNavigation}
        title="Millions deal with rosacea. At HolaVida, getting real results is simple, fast, and effective"
      />
    );
  }

  if (productSlug === "bb-ot") {
    return <BetaBlockersReviews onNavigate={handleNavigation} />;
  }

  if (productSlug === "sl-ot") {
    return (
      <SupplementsReviews onNavigate={handleNavigation} page="sl-reviews" />
    );
  }

  return <ResultExpectation onNavigate={handleNavigation} />;
};

export default Welcome2;
